import { ICustomRoute } from '../../app-routing.module';
import { AppLastImportsExportsComponent } from './last-imports-exports.component';

export const AppLastImportsExportsRoutes: ICustomRoute[] = [
  {
    path: 'imports-exports',
    component: AppLastImportsExportsComponent,
  },
];
